// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCfH_bJfdbGi58__C21AHweBsl-W4uWKNE",
  authDomain: "abt-tj.firebaseapp.com",
  projectId: "abt-tj",
  storageBucket: "abt-tj.firebasestorage.app",
  messagingSenderId: "596817136978",
  appId: "1:596817136978:web:77f070924e158757077e8b",
  measurementId: "G-YYK3J98XKP"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);